import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";

export default {
  // SecurityService.verifyGlobalPermission(this.getUser, 289, "noautorizado", this.$router, 'uslogin');
  verifyGlobalPermission(user, permission, pathName, router, uslogin) {
    if (
      !user.has(permission) ||
      user.get(permission).uslogin != uslogin ||
      !user.get(permission).uslogin
    ) {
      router.push({ name: pathName });
    }
  },

  // SecurityService.verifySinglePermission(this.getUser, 289, "index", this.$router, this.$swal);
  verifySinglePermission(
    user,
    permission,
    pathName,
    router,
    swal,
    title = "No tienes el permiso para ver este contenido",
    text = "¡Serás redireccionado al Inicio!",
    messageButton = "aceptar"
  ) {
    if (!user.has(permission)) {
      swal({
        type: "error",
        title: title,
        text: text,
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: messageButton,
        timer: 3000,
        onClose: () => {
          router.replace({ name: pathName });
        },
      }).then((result) => {
        if (result.value) {
          router.replace({ name: pathName });
        }
      });
    }
  },

  mensajeDeExpirarSesion(
    Vue,
    Store,
    title = "Ha finalizado tu sesión.",
    text = "¡Serás redireccionado al Login!",
    messageButton = "aceptar"
  ) {
    Store.dispatch("setChangeExpireSession", true);
    Vue.swal({
      type: "error",
      title: title,
      text: text,
      allowOutsideClick: false,
      showCancelButton: false,
      confirmButtonText: messageButton,
      timer: 10000,
    }).then((result) => {
      ManagerLocalStorage.removeLocalStorage(
        Store.state.informationPage.nameLocalStoragePGV2
      );
      MetodosGenerales.eliminaCookie(
        Store.state.informationPage.nameCookiePGV2
      );
      setTimeout(() => {
        location.reload();
      }, 100);
    });
  },

  checkSessionExpireRouter(
    next,
    Vue,
    Store,
    domain,
    title = "Ha finalizado tu sesión.",
    text = "¡Serás redireccionado al Login!",
    messageButton = "aceptar"
  ) {
    //console.log("entro a  checkSessionExpireRouter")
    if (!Store.state.informationPage.expireSession) {
      //console.log(!Store.state.informationPage.expireSession)
      Vue.axios
        .post(`${domain.domainNameForApi}expireSesion`)
        .then((response) => {
          Store.dispatch("setChangeExpireSession", response.data);
          if (!Store.state.informationPage.expireSession) {
            next();
          } else {
            next();
            Vue.swal({
              type: "error",
              title: title,
              text: text,
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: messageButton,
              timer: 10000,
            }).then((result) => {
              ManagerLocalStorage.removeLocalStorage(
                Store.state.informationPage.nameLocalStoragePGV2
              );
              MetodosGenerales.eliminaCookie(
                Store.state.informationPage.nameCookiePGV2
              );
              setTimeout(() => {
                window.location.reload();
              }, 100);
            });
          }
        });
    } else {
      Vue.swal({
        type: "error",
        title: title,
        text: text,
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: messageButton,
        timer: 10000,
      }).then((result) => {
        ManagerLocalStorage.removeLocalStorage(
          Store.state.informationPage.nameLocalStoragePGV2
        );
        MetodosGenerales.eliminaCookie(
          Store.state.informationPage.nameCookiePGV2
        );
        setTimeout(() => {
          windowlocation.reload();
        }, 100);
      });
    }
  },
};
